import { DownOutlined } from '@ant-design/icons';
import React, { Fragment, useState } from 'react';
import { Button, Dropdown } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';
import AddDefaultCategoryModal from '../AddDefaultCategoryModal';

const OrganisationActionsDropdown = ({ data, size, placement, showIcon = true, shape }) => {
	const [defaultCategoryVisibleModal, setDefaultCategoryVisibleModal] = useState(false);

	const items = [
		{
			key: 'addDefaultCategory',
			label: (
				<ConditionalTooltipButton
					buttonText={'Create Default Category'}
					onClick={() => setDefaultCategoryVisibleModal(true)}
				/>
			)
		}
	];

	return (
		<Fragment>
			<Dropdown arrow menu={{ items }} trigger={['click']} placement={placement || 'bottom'}>
				<Button
					style={{
						borderRadius: shape === 'circle' ? '10px' : null
					}}
					size={size || 'small'}
					type='primary'
				>
					Actions
					{showIcon && <DownOutlined />}
				</Button>
			</Dropdown>
			<AddDefaultCategoryModal
				open={defaultCategoryVisibleModal}
				setOpen={setDefaultCategoryVisibleModal}
				orgID={data.orgID}
			>
				<div />
			</AddDefaultCategoryModal>
		</Fragment>
	);
};

export default OrganisationActionsDropdown;
